<template>
  <div>
    <div class="sayfahead tek">
      <h1>Kullanıcı İşlemleri</h1>
      <el-button type="info" size="small" class="YeniBtn" @click="this.DuzenleBtn">
        Düzenle
      </el-button>
    </div>
    <div class="icerik">
      <el-row :gutter="24">
        <el-col :span="6">
          <BilgiKutu :data="BilgiKutu"></BilgiKutu>
          <Notlar :data="Notlar" v-if="Notlar"></Notlar>
        </el-col>
        <el-col :span="14">
          <el-row :gutter="24">
            <el-col :span="18">
              <el-date-picker
                v-model="LogTarih"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="Log Tarihi Seçiniz"
                format="dd.MM.yyyy">
              </el-date-picker>
            </el-col>
            <el-col :span="6">
              <el-button type="success" class="btn-block" @click="LogGetir">Log Getir</el-button>
            </el-col>
          </el-row>
          <hr>
          <div class="KullaniciLog">
            <el-table
              :height="Height"
              class="table-xs"
              v-if="LogListe"
              :data="LogListe">
              <el-table-column
                label="Tarih"
                prop="Tarih">
              </el-table-column>
              <el-table-column
                label="İşlem"
                prop="MethodText">
              </el-table-column>
              <el-table-column
                label="Url"
                prop="Url">
              </el-table-column>
            </el-table>
          </div>
        </el-col>
        <el-col :span="4">
          <BilgiKutu :data="YetkiBilgiKutu"></BilgiKutu>
        </el-col>
      </el-row>
    </div>
    <FormModal :data="Liste" :ModalOlayi="ModalOlayi" :Baslik="Baslik"
               @ModalOlayi="SayfaYukle"></FormModal>
  </div>

</template>

<script>
import FormModal from "../../components/Pack/Kulanici/FormModal";
import Notlar from "../../components/Pack/Genel/Notlar";
import BilgiKutu from "../../components/Pack/Genel/BilgiKutu";

export default {
  components: {BilgiKutu, Notlar, FormModal},
  data() {
    return {
      loading: false,
      Height: 0,
      ModalOlayi: false,
      Baslik: null,
      LogTarih: null,
      Liste: {},
      LogListe: null,
      Notlar: null,
      BilgiKutu: null,
      YetkiBilgiKutu: null,
      Yetkiler: {
        0: 'Yetki Yok',
        1: 'Sadece Görebilir',
        2: 'Tüm İşlemleri Gerçekleştirebilir'
      },
      Yetkilers: {
        0: 'İzin Yok',
        1: 'İzin Var'
      },
      FormData: {
        AdSoyad: null,
        Email: null,
        Telefon: null,
        durum: null,
        disabled: false,
        span: 8,
        Yetki: {
          yonetim: "0",
          vezne: "0",
          muhasebe: "0",
          kasa: "0",
          raporlama: "0",
          icra: "0",
          iletisim: "0",
          iptal: "0",
          spesiyal: "0",
          entegrasyon: "0",
          MakbuzIptal: "0",
          KVKK: "0",
          VezneTarih: "0",
          NotArsiv: "0",
          IcraTahsilat: "0",
        }
      },

    }
  },
  methods: {
    LogGetir() {
      if (this.LogTarih) {
        this.$store.dispatch("Get", {
          path: 'kullanici/log/' + this.$route.params.Kullanici_id + '/' + this.LogTarih
        })
          .then(response => {
            if (response.Durum === 'OK') {
              this.LogListe = response.Liste;
              this.Height = '75vh'
            } else {
              this.$message.error(response.Mesaj);
              this.hata = response.Hata;
            }
          });
      } else {
        this.$message.error("Log Tarihi Seçiniz");
      }

    },
    SayfaYukle() {
      this.ModalOlayi = false;
      this.$store.dispatch("Get", {
        path: 'kullanici/d/' + this.$route.params.Kullanici_id
      })
        .then(response => {
          if (response.Durum === 'OK') {
            this.Liste = response.Liste;
            this.Notlar = {
              Modul: 'Kullanici_Hesap',
              Modul_id: this.Liste.Kullanici_Hesap_id,
            };
            this.BilgiKutu = {
              Baslik: 'Kullanıcı Bilgi',
              Detay: [
                {Baslik: 'Ad Soyad', Bilgi: this.Liste.AdSoyad},
                {Baslik: 'Telefon', Bilgi: this.Liste.Telefon},
                {Baslik: 'Mail', Bilgi: this.Liste.Email},
                {Baslik: 'Durum', Bilgi: this.Liste.DurumText},
              ]
            };
            this.YetkiBilgiKutu = {
              Baslik: 'Yetkiler',
              Detay: [
                {Baslik: this.Yetkiler[this.Liste.Yetki.yonetim], Bilgi: 'Yönetim Modülü'},
                {Baslik: this.Yetkiler[this.Liste.Yetki.vezne], Bilgi: 'Vezne Modülü'},
                {Baslik: this.Yetkiler[this.Liste.Yetki.muhasebe], Bilgi: 'Muhasebe Modülü'},
                {Baslik: this.Yetkiler[this.Liste.Yetki.kasa], Bilgi: 'Kasa Modülü'},
                {Baslik: this.Yetkiler[this.Liste.Yetki.raporlama], Bilgi: 'Raporlama Modülü'},
                {Baslik: this.Yetkiler[this.Liste.Yetki.icra], Bilgi: 'Icra Modülü'},
                {Baslik: this.Yetkiler[this.Liste.Yetki.iletisim], Bilgi: 'İletişim Modülü'},
                {Baslik: this.Yetkiler[this.Liste.Yetki.iptal], Bilgi: 'İptal Modülü'},
                {Baslik: this.Yetkiler[this.Liste.Yetki.entegrasyon], Bilgi: 'Entegrasyon Yetkisi'},
                {Baslik: this.Yetkilers[this.Liste.Yetki.MakbuzIptal], Bilgi: 'Makbuz İptal Yetkisi'},
                {Baslik: this.Yetkilers[this.Liste.Yetki.KVKK], Bilgi: 'KVKK Yetkisi'},
                {Baslik: this.Yetkilers[this.Liste.Yetki.VezneTarih], Bilgi: 'Vezne Tarih Yetkisi'},
                {Baslik: this.Yetkilers[this.Liste.Yetki.NotArsiv], Bilgi: 'Not ve Arşiv Yetkisi'},
                {Baslik: this.Yetkilers[this.Liste.Yetki.IcraTahsilat], Bilgi: 'İcra Tahsilat Yetkisi'},
              ]
            };
          } else {
            this.$message.error(response.Mesaj);
            this.hata = response.Hata;
          }
        });

    },
    Getir() {
      this.loading = true;
      this.count += 20;
      this.loading = false
    },
    DuzenleBtn() {
      this.Baslik = this.Liste.AdSoyad + ' Düzenle';
      this.ModalOlayi = true;
      this.Liste.span = 6;
      this.Liste.disabled = true;
      if (this.Liste.Yetki == null) {
        this.Liste.Yetki = {
          yonetim: "0",
          vezne: "0",
          muhasebe: "0",
          kasa: "0",
          raporlama: "0",
          icra: "0",
          iletisim: "0",
          iptal: "0",
          spesiyal: "0",
          entegrasyon: "0",
          MakbuzIptal: "0",
          KVKK: "0",
          VezneTarih: "0",
          NotArsiv: "0",
          IcraTahsilat: "0",

        }
      }
      this.FormData = this.Liste

    },
  },
  created() {
    this.SayfaYukle();

  },
  computed: {
    noMore() {
      return this.count >= 1000
    },
    disabled() {
      return this.loading || this.noMore
    }
  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Kullanici/detay.vue